export enum AmountAggregatorType {
Amount,
Hours,
Days,
}
